module.exports = __webpack_public_path__ + "static/ski-a7bfcd15ad45b75bab1d791252600e0d.jpg";